import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_main/about")({
  component: About,
});

function About() {
  return (
    <div className="p-2 text-red-500">
      <h2>Hello from About!</h2>
    </div>
  );
}
